import { render, staticRenderFns } from "./SelectPageNumber.vue?vue&type=template&id=61c3a4c4"
import script from "./SelectPageNumber.vue?vue&type=script&lang=js"
export * from "./SelectPageNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports